import { render, staticRenderFns } from "./InvoiceSpreadsheet.vue?vue&type=template&id=4f8976eb&scoped=true&"
import script from "./InvoiceSpreadsheet.vue?vue&type=script&lang=js&"
export * from "./InvoiceSpreadsheet.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceSpreadsheet.vue?vue&type=style&index=0&id=4f8976eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8976eb",
  null
  
)

export default component.exports